<template>
    <confirmation-dialog
        :show="show"
        title=""
        :show-icon="false"
        :proceed-button-text="proceedButtonText"
        @proceed="updateOrCreate()"
        :proceed-disabled="form.busy "
        :show-cancel-button="!form.busy"
        cancel-button-text="Cancel"
        proceed-button-colour="indigo-600"
        proceed-button-hover-colour="indigo-800"
        @cancelled="closeModal()">

        <div slot="title" class="flex flex-col space-y-4 mb-4">
            <div class="flex justify-between items-center">
                <div class="flex items-center space-x-4">
                    <div class="h-10 w-10 text-white bg-indigo-600 p-1 rounded">
                        <common-issue-icons :category="form.category"></common-issue-icons>
                    </div>

                    <div class="text-indigo-600 font-bold text-lg">
                        {{ issue ? "Update" : "Create" }} Maintenance Request Option
                    </div>
                </div>
            </div>
        </div>

        <div slot="body" class="grid grid-cols-1 gap-4">
            <div class="col-span-1">
                <label class="font-medium text-md">Category</label>
                <el-autocomplete
                    class="w-full"
                    v-model="form.category"
                    :fetch-suggestions="categoriesListSearch"
                    placeholder="Plumbing">
                </el-autocomplete>
                <span class="text-brand text-xs" v-show="form.errors.has('category')">
                    {{ form.errors.get("category") }}
                </span>
            </div>

            <div class="col-span-1">
                <label class="font-medium text-md">Location</label>
                <text-input
                    class="w-full"
                    v-model="form.location"
                    placeholder="Bathroom">
                </text-input>
                <span class="text-brand text-xs" v-show="form.errors.has('location')">
                    {{ form.errors.get("location") }}
                </span>
            </div>

            <div class="col-span-1">
                <label class="font-medium text-md">Item</label>
                <el-autocomplete
                    class="w-full"
                    v-model="form.item"
                    :fetch-suggestions="itemNamesListSearch"
                    placeholder="Basin">
                </el-autocomplete>
                <span class="text-brand text-xs" v-show="form.errors.has('item')">
                    {{ form.errors.get("item") }}
                </span>
            </div>

            <div class="col-span-1">
                <label class="font-medium text-md">Description</label>
                <text-input
                    class="w-full"
                    v-model="form.description"
                    placeholder="Leaky">
                </text-input>
                <span class="text-brand text-xs" v-show="form.errors.has('description')">
                    {{ form.errors.get("description") }}
                </span>
            </div>
        </div>
    </confirmation-dialog>
</template>

<script>
import CommonIssueIcons from "./CommonIssueIcons";
import ItemsMixin from "../../mixins/item-name-list-search";

export default {
    name: "CommonMaintenanceRequestIssuesCreateEditModal",

    components: {CommonIssueIcons},

    mixins: [ItemsMixin],

    props: {
        show: {
            type: Boolean,
            required: true,
            description: "Show modal or not."
        },
        issue: {
            type: Object,
            required: false,
            description: "Used when editing an issue."
        },
        companyType: {
            type: String,
            required: true,
            description: "Used when creating and editing"
        }
    },

    data () {
        return {
            form: new AppForm({}),
            availableCategories: [],
        };
    },

    computed: {
        proceedButtonText () {
            if (this.form && this.form.busy) {
                return this.issue ? "Updating..." : "Creating Issue...";
            } else {
                return this.issue ? "Update" : "Create Issue";
            }
        }
    },

    watch: {
        issue (newIssue) {
            this.initForm(newIssue);
            // clear form when done editing
            if (!newIssue) {
                this.initForm();
            }
        },

        companyType (newVal) {
            if (newVal) {
                this.initForm();
            }
        }
    },

    mounted () {
        this.initForm(this.issue);
        this.getCategoriesList();
    },

    methods: {
        initForm (issue = null) {
            this.form = new AppForm({
                category: "",
                description: "",
                item: "",
                location: "",
                company_type: this.companyType
            });

            if (issue) {
                this.form.category = issue.category;
                this.form.description = issue.description;
                this.form.item = issue.item;
                this.form.location = issue.location;
                this.form.company_type = issue.for_company_type;
            }
        },

        updateOrCreate () {
            if (this.issue) {
                this.update();
            } else {
                this.create();
            }
        },

        create () {
            App.post("/settings/maintenance/requests/create-issue", this.form)
            .then(response => {
                toastr.success("Successfully Created Option");
                this.$emit("added-issue", response);
                this.closeModal();
            })
            .catch(error => {
                toastr.error(error.message);
            });
        },

        update () {
            App.patch(`/settings/maintenance/requests/edit-issue/${this.issue.id}`, this.form)
            .then(response => {
                toastr.success("Successfully Edited Option");
                this.$emit("edited-issue", response);
                this.closeModal();
            })
            .catch(error => {
                toastr.error(error.message);
            });
        },

        getCategoriesList () {
            axios.get("/settings/maintenance/requests/get-categories")
            .then(response => {
                response.data.forEach(category => this.availableCategories.push({"value": category}));
            });
        },

        categoriesListSearch (queryString, cb) {
            cb(queryString ? this.availableCategories.filter(category => category.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0) : this.availableCategories);
        },

        closeModal () {
            this.$emit("close");
        },
    },
};
</script>